/* eslint-disable react/forbid-dom-props */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { launchTelemetry } from '@shared/utils/reviewsUtils';
import { Constants } from '@shared/utils/constants';
import { Dropdown } from '@fluentui/react';
import { logger } from '@src/logger';
export var SourceFilterOptions = /*#__PURE__*/ function(SourceFilterOptions) {
    SourceFilterOptions["AllReviews"] = "All reviews";
    SourceFilterOptions["MarketplaceReviews"] = "Marketplace reviews";
    SourceFilterOptions["G2Reviews"] = "G2 reviews";
    SourceFilterOptions["MyReview"] = "My review";
    SourceFilterOptions["MyComments"] = "My comments";
    return SourceFilterOptions;
}({});
export var RatingsFilterOptions = /*#__PURE__*/ function(RatingsFilterOptions) {
    RatingsFilterOptions["AllRatings"] = "All ratings";
    RatingsFilterOptions["OneStar"] = "1 star";
    RatingsFilterOptions["TwoStars"] = "2 stars";
    RatingsFilterOptions["ThreeStars"] = "3 stars";
    RatingsFilterOptions["FourStars"] = "4 stars";
    RatingsFilterOptions["FiveStars"] = "5 stars";
    return RatingsFilterOptions;
}({});
export var SortByOptions = /*#__PURE__*/ function(SortByOptions) {
    SortByOptions["MostRecent"] = "Most recent";
    SortByOptions["HighToLow"] = "High to low";
    SortByOptions["LowToHigh"] = "Low to high";
    SortByOptions["MostHelpful"] = "Most Helpful";
    return SortByOptions;
}({});
export const isUserCommentsExist = (userCommentedReviewIds)=>userCommentedReviewIds.length > 0;
export function getFilterBySourceCategories(context, externalReviewsExist, userReviewExists, internalReviewsExist, userCommentsExist = false, showMyCommentsFilter = false) {
    const filterBySourceCategories = [
        {
            text: context.loc('AppReviewCollection_sourceFilter_AllReviews', 'All reviews'),
            key: "All reviews"
        }
    ];
    filterBySourceCategories.push({
        text: context.loc('AppReviewCollection_sourceFilter_MarketplaceReviews', 'Marketplace reviews'),
        key: "Marketplace reviews",
        disabled: !internalReviewsExist
    });
    filterBySourceCategories.push({
        text: context.loc('AppReviewCollection_sourceFilter_G2Reviews', 'G2 reviews'),
        key: "G2 reviews",
        disabled: !externalReviewsExist
    });
    filterBySourceCategories.push({
        text: context.loc('AppReviewCollection_sourceFilter_MyReview', 'My review'),
        key: "My review",
        disabled: !userReviewExists
    });
    if (showMyCommentsFilter) {
        filterBySourceCategories.push({
            text: context.loc('AppReviewCollection_sourceFilter_MyComments', 'My comments'),
            key: "My comments",
            disabled: !userCommentsExist
        });
    }
    return filterBySourceCategories;
}
export function getSourceFilterOptionByLocaliztionText({ text, context, userCommentsExist = false, showMyCommentsFilter = false }) {
    const allSourceOptions = getFilterBySourceCategories(context, true, true, true, userCommentsExist, showMyCommentsFilter);
    const optionsByText = allSourceOptions.find((option)=>option.text === text);
    return optionsByText || allSourceOptions[0];
}
export function getSortByCategories(context) {
    const sortByCategories = [
        {
            text: context.loc('AppReviewCollection_sortReviews_MostRecent', 'Most recent'),
            key: "Most recent"
        },
        {
            text: context.loc('AppReviewCollection_sortReviews_ByRatingHighToLow', 'Highest rating'),
            key: "High to low"
        },
        {
            text: context.loc('AppReviewCollection_sortReviews_ByRatingLowToHigh', 'Lowest rating'),
            key: "Low to high"
        },
        {
            text: context.loc('AppReviewCollection_sortReviews_MostHelpful', 'Most helpful'),
            key: "Most Helpful"
        }
    ];
    return sortByCategories;
}
export function getSortByOptionByLocaliztionText(text, context) {
    const allSortByOptions = getSortByCategories(context);
    const optionsByText = allSortByOptions.find((option)=>option.text === text);
    return optionsByText || allSortByOptions[0];
}
export function getRatingsFilterNumber(option) {
    switch(option.key){
        case "1 star":
            return 1;
        case "2 stars":
            return 2;
        case "3 stars":
            return 3;
        case "4 stars":
            return 4;
        case "5 stars":
            return 5;
        default:
            return null;
    }
}
export function getRatingsFilterOptionByRating(rating, context) {
    switch(rating){
        case 1:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_OneStar', '1 star'),
                key: "1 star"
            };
        case 2:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_TwoStars', '2 stars'),
                key: "2 stars"
            };
        case 3:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_ThreeStars', '3 stars'),
                key: "3 stars"
            };
        case 4:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_FourStars', '4 stars'),
                key: "4 stars"
            };
        case 5:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_FiveStars', '5 stars'),
                key: "5 stars"
            };
        default:
            return {
                text: context.loc('AppReviewCollection_ratingsFilter_AllRatings', 'All ratings'),
                key: "All ratings"
            };
    }
}
export function getRatingsFilterCategories(context) {
    const ratingsFilterCategories = [
        {
            text: context.loc('AppReviewCollection_ratingsFilter_AllRatings', 'All ratings'),
            key: "All ratings"
        },
        {
            text: context.loc('AppReviewCollection_ratingsFilter_OneStar', '1 star'),
            key: "1 star"
        },
        {
            text: context.loc('AppReviewCollection_ratingsFilter_TwoStars', '2 stars'),
            key: "2 stars"
        },
        {
            text: context.loc('AppReviewCollection_ratingsFilter_ThreeStars', '3 stars'),
            key: "3 stars"
        },
        {
            text: context.loc('AppReviewCollection_ratingsFilter_FourStars', '4 stars'),
            key: "4 stars"
        },
        {
            text: context.loc('AppReviewCollection_ratingsFilter_FiveStars', '5 stars'),
            key: "5 stars"
        }
    ];
    return ratingsFilterCategories;
}
export function handleRatingsFilter(option, isDropDownChanged, originalReviewList) {
    let filteredArray = [];
    const updatedRatingsFilter = getRatingsFilterNumber(option);
    if (isDropDownChanged) {
        filteredArray = updatedRatingsFilter ? originalReviewList.filter((review)=>review.rating === updatedRatingsFilter) : originalReviewList;
        const telemetryDetails = {
            ratingsFilter: updatedRatingsFilter
        };
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.FilterPDPReviews, telemetryDetails);
        logger.info(JSON.stringify(telemetryDetails), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPDPReviews
        });
    }
    return filteredArray;
}
export function filterBySource(option, reviewsList, userReview, userCommentedReviewIds) {
    switch(option.key){
        case "Marketplace reviews":
            return reviewsList.filter((review)=>Constants.InternalStoreFronts.indexOf(review.source) > -1);
        case "G2 reviews":
            return reviewsList.filter((review)=>review.source === Constants.StorefrontName.G2);
        case "My review":
            reviewsList = userReview ? [
                userReview
            ] : [];
            return reviewsList;
        case "My comments":
            return reviewsList.filter((review)=>userCommentedReviewIds.indexOf(review.id) > -1);
        default:
            return reviewsList;
    }
}
export function handleSourceFilter(option, isDropDownChanged, reviewsList, userReview, userCommentedReviewIds) {
    let filteredArray = [];
    if (isDropDownChanged) {
        filteredArray = filterBySource(option, reviewsList, userReview, userCommentedReviewIds);
        const telemetryDetails = {
            reviewsSourceFilter: option.text
        };
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.FilterPDPReviews, telemetryDetails);
        logger.info(JSON.stringify(telemetryDetails), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.FilterPDPReviews
        });
    }
    return filteredArray;
}
export function getSortByStatus(curReviewsList, option, isDropDownChanged, curSortBy, context) {
    const sortByHelper = {
        sortedReviewsList: curReviewsList,
        updatedSortBy: curSortBy
    };
    switch(option.key){
        case "High to low":
            sortByHelper.updatedSortBy = context.loc('AppReviewCollection_sortReviews_ByRatingHighToLow');
            if (isDropDownChanged) {
                sortByHelper.sortedReviewsList = sortByHelper.sortedReviewsList.sort((first, second)=>second.rating - first.rating);
            }
            break;
        case "Low to high":
            sortByHelper.updatedSortBy = context.loc('AppReviewCollection_sortReviews_ByRatingLowToHigh');
            if (isDropDownChanged) {
                sortByHelper.sortedReviewsList = sortByHelper.sortedReviewsList.sort((first, second)=>first.rating - second.rating);
            }
            break;
        case "Most Helpful":
            sortByHelper.updatedSortBy = context.loc('AppReviewCollection_sortReviews_MostHelpful');
            if (isDropDownChanged) {
                sortByHelper.sortedReviewsList = sortByHelper.sortedReviewsList.sort((first, second)=>second.mark_as_helpful_count - first.mark_as_helpful_count);
            }
            break;
        default:
            sortByHelper.updatedSortBy = context.loc('AppReviewCollection_sortReviews_MostRecent');
            if (isDropDownChanged) {
                sortByHelper.sortedReviewsList = sortByHelper.sortedReviewsList.sort((first, second)=>new Date(second.updated_at).valueOf() - new Date(first.updated_at).valueOf());
            }
            break;
    }
    return sortByHelper;
}
export function handleSortBy(option, updatedReviewsList, curReviewsList, isDropDownChanged, sortBy, context, updateReviewsSortByState) {
    const sortByHelper = getSortByStatus(updatedReviewsList, option, isDropDownChanged, sortBy, context);
    if (curReviewsList && isDropDownChanged) {
        updateReviewsSortByState(sortByHelper.updatedSortBy);
        const telemetryDetails = {
            sortBy: sortByHelper.updatedSortBy
        };
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.SortPDPReviews, telemetryDetails);
        logger.info(JSON.stringify(telemetryDetails), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.SortPDPReviews
        });
    }
    return sortByHelper.sortedReviewsList;
}
export function handleDropDowns(sourceFilterOption, ratingFilterOption, sortByOption, updateReviewsState, originalReviewList, curReviewsList, sourceFilter, sortBy, ratingFilter, context, userReview, userCommentedReviewIds = []) {
    const updatedRatingsFilter = getRatingsFilterNumber(ratingFilterOption);
    const isDropDownChanged = ratingFilter !== updatedRatingsFilter || sortBy !== sortByOption.text || sourceFilterOption.text !== sourceFilter;
    let filteredArray = handleRatingsFilter(ratingFilterOption, isDropDownChanged, originalReviewList);
    filteredArray = handleSourceFilter(sourceFilterOption, isDropDownChanged, filteredArray, userReview, userCommentedReviewIds);
    const fliteredAndSortedArray = handleSortBy(sortByOption, filteredArray, curReviewsList, isDropDownChanged, sortBy, context, updateReviewsState.updateStateBySortFilter);
    if (isDropDownChanged) {
        updateReviewsState.updateStateByFilters(updatedRatingsFilter, fliteredAndSortedArray, sourceFilterOption.text);
    }
    // Go to first page and update pagination if the reviews list was changed
    if (fliteredAndSortedArray.length) {
        const updatedCurrentEnd = Constants.MaxItemsPerPageInReviews < filteredArray.length ? Constants.MaxItemsPerPageInReviews : filteredArray.length;
        updateReviewsState.updatePaginationState(1, 1, updatedCurrentEnd);
    }
}
export function renderSourceFilterDropDown({ curSortBy, curRatingFilter, context, updateReviewsState, originalReviewList, curReviewsList, curSourceFilter, externalReviewsExist, userReview, internalReviewsExist, userCommentedReviewIds, showMyCommentsFilter }) {
    const sourceFilterCategories = getFilterBySourceCategories(context, externalReviewsExist, !!userReview, internalReviewsExist, isUserCommentsExist(userCommentedReviewIds), showMyCommentsFilter);
    let activeFilterOption = sourceFilterCategories.find((option)=>option.text === curSourceFilter);
    activeFilterOption = activeFilterOption !== null && activeFilterOption !== void 0 ? activeFilterOption : sourceFilterCategories[0];
    return /*#__PURE__*/ _jsx(Dropdown, {
        className: "reviewDropDown sourceFilter",
        defaultSelectedKey: activeFilterOption.key,
        options: sourceFilterCategories,
        dropdownWidth: 'grow',
        ariaLabel: activeFilterOption.text,
        onChange: (e, option)=>{
            const sortBy = getSortByOptionByLocaliztionText(curSortBy, context);
            const ratingFilter = getRatingsFilterOptionByRating(curRatingFilter, context);
            handleDropDowns(option, ratingFilter, sortBy, updateReviewsState, originalReviewList, curReviewsList, curSourceFilter, curSortBy, curRatingFilter, context, userReview, userCommentedReviewIds);
        }
    });
}
export function renderRatingFilterDropDown(curSortBy, curSourceFilter, updateReviewsState, originalReviewList, curReviewsList, curRatingFilter, context, userReview, userCommentedReviewIds, showMyCommentsFilter) {
    const ratingsFilterCategories = getRatingsFilterCategories(context);
    const curRatingFilterOption = getRatingsFilterOptionByRating(curRatingFilter, context);
    let activeFilterOption = ratingsFilterCategories.find((option)=>option.text === curRatingFilterOption.text);
    activeFilterOption = activeFilterOption !== null && activeFilterOption !== void 0 ? activeFilterOption : ratingsFilterCategories[0];
    return /*#__PURE__*/ _jsx(Dropdown, {
        className: "reviewDropDown ratingFilter",
        defaultSelectedKey: activeFilterOption.key,
        options: ratingsFilterCategories,
        ariaLabel: curRatingFilterOption.text,
        dropdownWidth: 'grow',
        onChange: (e, option)=>{
            const sortBy = getSortByOptionByLocaliztionText(curSortBy, context);
            const sourceFilter = getSourceFilterOptionByLocaliztionText({
                text: curSourceFilter,
                context: context,
                userCommentsExist: isUserCommentsExist(userCommentedReviewIds),
                showMyCommentsFilter: showMyCommentsFilter
            });
            handleDropDowns(sourceFilter, option, sortBy, updateReviewsState, originalReviewList, curReviewsList, curSourceFilter, curSortBy, curRatingFilter, context, userReview, userCommentedReviewIds);
        }
    });
}
export function renderSortByDropDown({ curRatingFilter, context, curSourceFilter, updateReviewsState, originalReviewList, curReviewsList, curSortBy, userReview, userCommentedReviewIds, showMyCommentsFilter }) {
    const sortByCategories = getSortByCategories(context);
    let activeFilterOption = sortByCategories.find((option)=>option.text === curSortBy);
    activeFilterOption = activeFilterOption !== null && activeFilterOption !== void 0 ? activeFilterOption : sortByCategories[0];
    return /*#__PURE__*/ _jsx(Dropdown, {
        className: "reviewDropDown sortByDropDown",
        defaultSelectedKey: activeFilterOption.key,
        options: sortByCategories,
        "aria-labelledby": "reviewsSortByLabel",
        dropdownWidth: 'grow',
        ariaLabel: context.loc('AppReviewCollection_sortReviews_TitleText', 'Sort by'),
        onChange: (e, option)=>{
            const ratingFilter = getRatingsFilterOptionByRating(curRatingFilter, context);
            const sourceFilter = getSourceFilterOptionByLocaliztionText({
                text: curSourceFilter,
                context: context,
                userCommentsExist: isUserCommentsExist(userCommentedReviewIds),
                showMyCommentsFilter: showMyCommentsFilter
            });
            handleDropDowns(sourceFilter, ratingFilter, option, updateReviewsState, originalReviewList, curReviewsList, curSourceFilter, curSortBy, curRatingFilter, context, userReview, userCommentedReviewIds);
        }
    });
}
export const ReviewsDropDowns = ({ curSourceFilter = null, curSortBy = null, curRatingFilter = null, context = null, updateReviewsState = null, originalReviewList = [], curReviewsList = [], externalReviewsExist = false, userReview = null, internalReviewsExist = false, userCommentedReviewIds = [], showMyCommentsFilter = false })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "reviewsTopBarDropDowns",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "reviewsFilter",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "sourceFilterIcon"
                    }),
                    renderSourceFilterDropDown({
                        curSortBy,
                        curRatingFilter,
                        context,
                        updateReviewsState,
                        originalReviewList,
                        curReviewsList,
                        curSourceFilter,
                        externalReviewsExist,
                        internalReviewsExist,
                        userReview,
                        userCommentedReviewIds,
                        showMyCommentsFilter
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "reviewsFilter",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "ratingsFilterIcon"
                    }),
                    renderRatingFilterDropDown(curSortBy, curSourceFilter, updateReviewsState, originalReviewList, curReviewsList, curRatingFilter, context, userReview, userCommentedReviewIds, showMyCommentsFilter)
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "reviewsSortBy",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "sortByIconAndText",
                        id: "reviewsSortByLabel",
                        children: context.loc('AppReviewCollection_sortReviews_TitleText')
                    }),
                    renderSortByDropDown({
                        curRatingFilter,
                        context,
                        curSourceFilter,
                        updateReviewsState,
                        originalReviewList,
                        curReviewsList,
                        curSortBy,
                        userReview,
                        userCommentedReviewIds,
                        showMyCommentsFilter
                    })
                ]
            })
        ]
    });
};
